import AMPLITUDE from '@/constants/amplitude'
import useAmplitudeTestAB from '@/hooks/useAmplitudeTestAB'

const variantControl = 'control-cro-ton-057'
const variantB = 'var-b-cro-ton-057'

export function useCROTon057() {
  const { activeVariant } = useAmplitudeTestAB(AMPLITUDE.TESTS.CRO_TON_057)

  const isControl_057 = activeVariant === variantControl
  const isVarB = activeVariant === variantB

  return { isControl_057, isVarB }
}
